export enum UcestalostEnum {
  Dnevno = 'Dnevno',
  Nedeljno = 'Nedeljno',
  Mesecno = 'Mesečno',
  RadniDani = 'Radni dani',
  Vikendi = 'Vikendi',
}



// WEBPACK FOOTER //
// ./src/app/enums/ucestalost.enum.ts